import React, { useEffect, useRef, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/index.css";
import "../styles/CategorySidebar.css";

const CategorySidebar = ({ categories, selectedCat, handleCategory }) => {
  const listRef = useRef(null);
  const isScrolling = useRef(false);
  const lockTimer = useRef(null);

  const sortedCategories = useMemo(() => {
    return [...categories].sort((a, b) => {
      const getOrder = (val) => {
        if (val === null || val === undefined || val === "") return 9999;
        const num = Number(val);
        return isNaN(num) ? 9999 : num;
      };
      const orderA = getOrder(a.order);
      const orderB = getOrder(b.order);
      if (orderA !== orderB) return orderA - orderB;
      return (a.category_name || "").localeCompare(b.category_name || "");
    });
  }, [categories]);

  useEffect(() => {
    if (!listRef.current || selectedCat === null) return;
    if (isScrolling.current) return;

    const activeItem = listRef.current.querySelector(".category-item.active");
    if (!activeItem) return;

    isScrolling.current = true;
    activeItem.scrollIntoView({ behavior: "smooth", block: "nearest" });

    clearTimeout(lockTimer.current);
    lockTimer.current = setTimeout(() => {
      isScrolling.current = false;
    }, 600);
  }, [selectedCat]);

  useEffect(() => {
    return () => clearTimeout(lockTimer.current);
  }, []);

  return (
    <div className="category-sidebar d-none d-lg-flex flex-column">
      <div className="category-header">Categories</div>

      <div className="sidebar-scroll-area" ref={listRef}>
        <ul className="category-list">
          {sortedCategories.map((cat) => {
            const isActive = selectedCat === cat.id;
            return (
              <li
                key={cat.id}
                className={`category-item ${isActive ? "active" : ""}`}
                onClick={() => handleCategory(cat.id)}
              >
                <div className="category-item-inner">
                  <span className="category-name">{cat.category_name}</span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default CategorySidebar;